export const homeTranslations = {
    ru: {
        hero: {
            sale: 'ПРОДАЁТСЯ',
            title: '3-ЭТАЖНЫЙ',
            subtitle: 'ДОМ В ЦЕНТРЕ БАТУМИ',
            address: 'ул. Генерала Мазниашвили 23, Батуми',

            area: '108м²',
            areaLabel: 'Площадь дома',

            floorsLabel: 'Этажа',
            priceLabel: 'Цена',
            price: '$295,000',

            contact: 'Связаться',

            morePhotos: 'Остались вопросы? Задайте их прямо владельцу',
        },

        benefits: {
            title: 'Преимущества',
            items: [
                {
                    icon: 'city',
                    title: 'Центр города',
                    text: 'Идеальное расположение в самом сердце Батуми',
                },
                {
                    icon: 'walk',
                    title: '10 минут до пляжа',
                    text: 'Пешая доступность до набережной',
                },
                {
                    icon: 'business',
                    title: 'Подходит для бизнеса',
                    text: 'Выгодная инвестиция с высоким потенциалом',
                },
                {
                    icon: 'growth',
                    title: 'Перспектива расширения',
                    text: 'Дом имеет крепкое основание и позволяет увеличить площадь за счёт достройки дополнительных этажей',
                },
            ],
        },

        details: {
            about: {
                title: 'О доме',
                texts: [
                    'Дом расположен в самом сердце старого Батуми. Одна сторона дома выходит на улицу Царя Парнаваза, где находится Piazza Batumi — одна из самых узнаваемых и посещаемых туристических локаций города.',
                    'Батуми ежегодно принимает миллионы туристов, и основной прогулочный поток проходит именно через район Пьяццы. Вход в дом и веранда расположены со стороны улицы Мазниашвили, одной из самых атмосферных улиц старого города.',
                ],

                params: [
                    { label: 'Тип недвижимости', value: 'Дом' },
                    { label: 'Площадь дома', value: '108м²' },
                    { label: 'Этажей', value: '3' },
                    { label: 'Год постройки', value: '1997' },
                    { label: 'Сделка', value: 'Без посредников' },
                ],
            },

            planning: {
                title: 'Планировка',
                floors: [
                    { title: '1 этаж' },
                    { title: '2 этаж' },
                    { title: '3 этаж' },
                ],
            },

            location: {
                title: 'Локация',
                button: 'Посмотреть на карте',
            },
        },

        gallery: {
            title: 'Галерея',

            showAll: 'Смотреть все фото',

            tabs: {
                all: 'Все',
                floor_1: 'Первый этаж',
                floor_2: 'Второй этаж',
                floor_3: 'Третий этаж',
                street: 'С улицы',
                window: 'Вид из окна',
            },
        },

        cadastre: {
            badge: 'Кадастровые данные',
            title: 'Два кадастровых номера',
            text: 'Дом оформлен как две отдельные кадастровые единицы: первый этаж имеет отдельный номер, а второй и третий этажи зарегистрированы под другим номером.',
            items: [
                {
                    title: 'Первый этаж',
                    number: '05.21.23.008.01.507',
                },
                {
                    title: 'Второй и третий этажи',
                    number: '05.21.23.008.01.508',
                },
            ],
        },

        footer: {
            title: 'Заинтересовались?',
            subtitle: 'Свяжитесь напрямую с владельцем',
            call: 'или позвоните',
            rights: 'Все права защищены.',
            made: 'Разработано в X-Devs',

            platforms: {
                badge: 'Также размещено на',
                title: 'Платформах недвижимости',
                text: 'Объект также опубликован на крупных грузинских площадках недвижимости.',
            },
        },
    },

    en: {
        hero: {
            sale: 'FOR SALE',
            title: '3-STOREY',
            subtitle: 'HOUSE IN CENTRAL BATUMI',
            address: '23 General Mazniashvili St, Batumi',

            area: '108m²',
            areaLabel: 'House area',

            floorsLabel: 'Floors',
            priceLabel: 'Price',
            price: '$295,000',

            contact: 'Contact',

            morePhotos: 'Have questions? Contact the owner directly',
        },

        benefits: {
            title: 'Advantages',
            items: [
                {
                    icon: 'city',
                    title: 'City Center',
                    text: 'Prime location in the heart of Batumi',
                },
                {
                    icon: 'walk',
                    title: '10 minutes to the beach',
                    text: 'Walking distance to the seaside boulevard',
                },
                {
                    icon: 'business',
                    title: 'Perfect for business',
                    text: 'A high-potential investment opportunity',
                },
                {
                    icon: 'growth',
                    title: 'Expansion potential',
                    text: 'The house has a solid foundation and allows additional floors to be built in the future',
                },
            ],
        },

        details: {
            about: {
                title: 'About the house',

                texts: [
                    'The house is located in the heart of Old Batumi. One side of the property faces King Parnavaz Street, home to Piazza Batumi — one of the city’s most iconic and visited tourist destinations.',
                    'Batumi welcomes millions of tourists every year, and the main pedestrian flow passes directly through the Piazza district. The entrance and veranda face Mazniashvili Street — one of the most atmospheric streets in the historic center.',
                ],

                params: [
                    { label: 'Property type', value: 'House' },
                    { label: 'House area', value: '108m²' },
                    { label: 'Floors', value: '3' },
                    { label: 'Year built', value: '1997' },
                    { label: 'Sale type', value: 'Direct sale by owner' },
                ],
            },

            planning: {
                title: 'Floor Plans',
                floors: [
                    { title: '1st Floor' },
                    { title: '2nd Floor' },
                    { title: '3rd Floor' },
                ],
            },

            location: {
                title: 'Location',
                button: 'View on map',
            },
        },

        gallery: {
            title: 'Gallery',

            showAll: 'View all photos',

            tabs: {
                all: 'All',
                floor_1: 'First Floor',
                floor_2: 'Second Floor',
                floor_3: 'Third Floor',
                street: 'Street View',
                window: 'View from window',
            },
        },

        cadastre: {
            badge: 'Property registry',
            title: 'Two cadastral numbers',
            text: 'The house is registered as two separate cadastral units: the first floor has its own number, while the second and third floors are registered under another number.',
            items: [
                {
                    title: 'First floor',
                    number: '05.21.23.008.01.507',
                },
                {
                    title: 'Second and third floors',
                    number: '05.21.23.008.01.508',
                },
            ],
        },

        footer: {
            title: 'Interested?',
            subtitle: 'Contact the owner directly',
            call: 'or call',
            rights: 'All rights reserved.',
            made: 'Developed by X-Devs',

            platforms: {
                badge: 'Also listed on',
                title: 'Real estate platforms',
                text: 'This property is also published on major Georgian real estate marketplaces.',
            },
        },
    },

    ka: {
        hero: {
            sale: 'იყიდება',
            title: '3-სართულიანი',
            subtitle: 'სახლი ბათუმის ცენტრში',
            address: 'გენერალ მაზნიაშვილის ქ. 23, ბათუმი',

            area: '108მ²',
            areaLabel: 'სახლის ფართობი',

            floorsLabel: 'სართული',
            priceLabel: 'ფასი',
            price: '$295,000',

            contact: 'დაკავშირება',

            morePhotos: 'დაგრჩათ კითხვები? დაუკავშირდით მფლობელს პირდაპირ',
        },

        benefits: {
            title: 'უპირატესობები',
            items: [
                {
                    icon: 'city',
                    title: 'ქალაქის ცენტრი',
                    text: 'იდეალური მდებარეობა ბათუმის გულში',
                },
                {
                    icon: 'walk',
                    title: '10 წუთი სანაპირომდე',
                    text: 'ზღვისპირამდე ფეხით მისასვლელი მანძილი',
                },
                {
                    icon: 'business',
                    title: 'იდეალურია ბიზნესისთვის',
                    text: 'მაღალი პოტენციალის მქონე მომგებიანი ინვესტიცია',
                },
                {
                    icon: 'growth',
                    title: 'გაფართოების პერსპექტივა',
                    text: 'სახლს აქვს მყარი საფუძველი და შესაძლებელია დამატებითი სართულების აშენება',
                },
            ],
        },

        details: {
            about: {
                title: 'სახლის შესახებ',

                texts: [
                    'სახლი მდებარეობს ძველი ბათუმის გულში. სახლის ერთი მხარე გადის მეფე ფარნავაზის ქუჩაზე, სადაც მდებარეობს Piazza Batumi — ქალაქის ერთ-ერთი ყველაზე ცნობილი და მონახულებადი ტურისტული ადგილი.',
                    'ბათუმი ყოველწლიურად მილიონობით ტურისტს მასპინძლობს და ძირითადი საფეხმავლო ნაკადი სწორედ პიაცას რაიონში გადის. სახლის შესასვლელი და ვერანდა მდებარეობს მაზნიაშვილის ქუჩის მხრიდან — ძველი ბათუმის ერთ-ერთ ყველაზე ატმოსფერულ ქუჩაზე.',
                ],

                params: [
                    { label: 'უძრავი ქონების ტიპი', value: 'სახლი' },
                    { label: 'სახლის ფართობი', value: '108მ²' },
                    { label: 'სართულები', value: '3' },
                    { label: 'აშენების წელი', value: '1997' },
                    { label: 'გარიგება', value: 'პირდაპირ მფლობელისგან' },
                ],
            },

            planning: {
                title: 'გეგმარება',
                floors: [
                    { title: '1 სართული' },
                    { title: '2 სართული' },
                    { title: '3 სართული' },
                ],
            },

            location: {
                title: 'ლოკაცია',
                button: 'რუკაზე ნახვა',
            },
        },

        gallery: {
            title: 'გალერეა',

            showAll: 'ყველა ფოტოს ნახვა',

            tabs: {
                all: 'ყველა',
                floor_1: 'პირველი სართული',
                floor_2: 'მეორე სართული',
                floor_3: 'მესამე სართული',
                street: 'ქუჩიდან',
                window: 'ხედი ფანჯრიდან',
            },
        },

        cadastre: {
            badge: 'საკადასტრო მონაცემები',
            title: 'ორი საკადასტრო ნომერი',
            text: 'სახლი რეგისტრირებულია როგორც ორი ცალკე საკადასტრო ერთეული: პირველ სართულს აქვს საკუთარი ნომერი, ხოლო მეორე და მესამე სართულები რეგისტრირებულია სხვა ნომრით.',
            items: [
                {
                    title: 'პირველი სართული',
                    number: '05.21.23.008.01.507',
                },
                {
                    title: 'მეორე და მესამე სართულები',
                    number: '05.21.23.008.01.508',
                },
            ],
        },

        footer: {
            title: 'დაინტერესდით?',
            subtitle: 'დაუკავშირდით მფლობელს პირდაპირ',
            call: 'ან დარეკეთ',
            rights: 'ყველა უფლება დაცულია.',
            made: 'შემუშავებულია X-Devs-ის მიერ',

            platforms: {
                badge: 'ასევე განთავსებულია',
                title: 'უძრავი ქონების პლატფორმებზე',
                text: 'ობიექტი ასევე გამოქვეყნებულია საქართველოს მთავარ უძრავი ქონების პლატფორმებზე.',
            },
        },
    },
};
